import { useAuth } from "../context/AppContext";
import { HAS_FIREBASE } from "../lib/firebase";
import { resendVerification, refreshVerification, signOut } from "../lib/dataStore";
import { MailWarning } from "lucide-react";
import { toast } from "sonner";

export default function VerifyBanner() {
  const { user } = useAuth();
  if (!HAS_FIREBASE || !user) return null;
  if (user.emailVerified !== false) return null; // verified or unknown -> hide

  return (
    <div data-testid="verify-banner" className="bg-ochre/30 border-b border-ochre/50 text-foreground">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-3 flex flex-wrap items-center gap-3 text-sm">
        <MailWarning className="w-4 h-4 shrink-0" />
        <span className="flex-1 min-w-[220px]">
          Please verify your email <strong>{user.email}</strong> to unlock ordering and account access.
        </span>
        <button
          data-testid="banner-refresh"
          onClick={async () => { const ok = await refreshVerification(); ok ? (toast.success("Verified!"), window.location.reload()) : toast.error("Not verified yet"); }}
          className="px-3 py-1 rounded-full border border-foreground/30 hover:bg-foreground hover:text-background text-xs"
        >
          I've verified
        </button>
        <button
          data-testid="banner-resend"
          onClick={async () => { try { await resendVerification(); toast.success("Verification email re-sent"); } catch { toast.error("Could not resend"); } }}
          className="px-3 py-1 rounded-full border border-foreground/30 hover:bg-foreground hover:text-background text-xs"
        >
          Resend
        </button>
        <button
          data-testid="banner-signout"
          onClick={() => signOut()}
          className="px-3 py-1 text-xs underline underline-offset-4"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
